export enum ItemTypesEquip {
  EQUIPMENT = 'EQUIPMENT',
}